// extracted by mini-css-extract-plugin
module.exports = {"container":"Reinsurance_container__EChYK","icon":"Reinsurance_icon__F7mPk","text":"Reinsurance_text__S6P89","action":"Reinsurance_action__fIUIR"};